/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHomePageDataSelector } from ".";
import { Img } from "../../Common/element/Img";

export default function PagePopOver() {
  const pageData = useHomePageDataSelector();
  const [showPopOver, setShowPopOver] = useState<boolean>(true);
  const [appOfTheWeek, setAppOfTheWeek] = useState(
    useHomePageDataSelector().appOfTheWeek
  );
  useEffect(() => {
    setAppOfTheWeek(pageData.appOfTheWeek);
  }, [pageData.appOfTheWeek]);
  return (
    <div
      className={
        showPopOver ? "page-popover shadow-lg" : "page-popover shadow-lg d-none"
      }
    >
      <div className="page-popover__icon">
        <i className="fas fa-award fa-3x"></i>
      </div>
      <div className="page-popover__content">
        <span
          style={{ cursor: "pointer" }}
          className="page-popover__close"
          onClick={() => {
            setShowPopOver(false);
          }}
        >
          <i className="fas fa-times-circle"></i>
        </span>
        <div className="page-popover__content-img">
          <div className="page-popover__content-label">
            Most Popular App This Week
          </div>
          <Img src={appOfTheWeek?.appIcon || ""} />
        </div>
        <div className="page-popover__content__text">
          <p className="m-0">{appOfTheWeek?.appName}</p>
        </div>
        <Link
          className="btn btn-light page-popover__content__text-link"
          to={"/app-details/" + appOfTheWeek?.appId}
        >
          <i className="fas fa-arrow-right"></i>
        </Link>
      </div>
    </div>
  );
}
